<template>
  <h3 class="mb-0 mt-4">{{ getFullname }}</h3>
  <p v-if="data.function" class="text-muted mb-0">{{ data.function }}</p>
  <a v-if="data.email_address" :href="'mailto:'+data.email_address"
     class="text-nowrap btn btn-link p-0">
    <i class="fa fa-envelope"></i> {{ data.email_address }}
  </a>
</template>

<script>
export default {
  name: 'AccountObject',

  props: {
    data: Object
  },

  computed: {
    getFullname() {
      return (this.data.account.user_firstname + ' ' + this.data.account.user_lastname).trim();
    }
  }
}
</script>
